/** API base URL - taken from VITE_API_BASE_URL or sensible localhost default. */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:4444';

/**
 * Google OAuth web client ID for "Sign in with Google". When unset, the
 * Google button is simply not rendered.
 */
export const GOOGLE_CLIENT_ID: string = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';

/**
 * Sign in with Apple: the Services ID from the Apple Developer portal (not
 * the app bundle ID). When unset, the Apple button is simply not rendered.
 * The redirect URI must be a return URL registered on that Services ID;
 * defaults to the current origin's /login.
 */
export const APPLE_CLIENT_ID: string = import.meta.env.VITE_APPLE_CLIENT_ID ?? '';
export const APPLE_REDIRECT_URI: string = import.meta.env.VITE_APPLE_REDIRECT_URI ?? '';
